module.exports = __webpack_public_path__ + "static/media/techsphere.3cc63d9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/techsphere.png
// module id = 138
// module chunks = 0